// extracted by css-extract-rspack-plugin
export default {"cls1":"RecommendedPodcasts-cls1_xP3","cls2":"RecommendedPodcasts-cls2_JTj RecommendedPodcasts-cls1_xP3"};